import {
  put, takeLatest,
} from 'redux-saga/effects'
import request from '@/helpers/axios'
import {
  successCreateProject,
} from '@/store/actions/installation/createProject'
import {
  PROJECT,
} from '@/constants/objectTypes'
import { CREATE_PROJECT } from '@/store/actions/installation'
import { INSTALLATIONS_PROJECT_ENDPOINT } from '@/constants/apiRoutes'
import createNotifications from '@/helpers/notification'
import { setGlobalLoading } from '@/store/actions/appSettings'
import { requestGetRootElements } from '@/store/actions/installation/getRootElemenet'
import { buildInstallationNodePath } from '@/helpers/installationTreeNode'
import { refreshInstallationTreeParent } from '@/store/sagas/installation/refreshInstallationTreeParent'
import { buildInstallationViewParams } from '@/helpers/installationViewParams'

function* createProjectSaga({ payload }) {
  const { formValues, values, setUrlFormValues, onComplete } = payload
  const {
    customFields = [], mark, name,
  } = values
  const toast = createNotifications()
  try {
    yield put(setGlobalLoading(true))
    const filterFields = (customFields || []).filter((element) => !!element.remove === false)
    const formattedCustomFields = filterFields.map((element) => ({
      nameField: element.nameField,
      value: element.value,
    }))
    const body = {
      name,
      note: mark,
      parentId: formValues.id,
      customFields: formattedCustomFields,
    }
    const { data } = yield request({
      url: INSTALLATIONS_PROJECT_ENDPOINT,
      method: 'post',
      body,
    })

    const {
      id, rootId, path, FILTER,
    } = formValues

    const basePath = id && path ? path.replace(String(id), String(data.parentId)) : path
    const projectPath = buildInstallationNodePath(basePath, data.id)

    const treeRefreshed = yield refreshInstallationTreeParent({
      parentId: data.parentId,
      nodeId: data.id,
      path,
    })

    if (!treeRefreshed) {
      yield put(requestGetRootElements())
    }

    setUrlFormValues(buildInstallationViewParams({
      id: data.id,
      type: PROJECT,
      parentGeoZoneId: data.parentId,
      rootId,
      ...(projectPath ? { path: projectPath } : {}),
      parentTreeId: data.parentId,
      FILTER,
    }))

    yield put(setGlobalLoading(false))
    toast({
      title: 'Создание проекта',
      type: 'success',
      description: 'Проект успешно создан.',
    })

    if (onComplete) {
      onComplete()
    }

    yield put(successCreateProject())
  } catch (error) {
    yield put(setGlobalLoading(false))
    const { FILTER } = formValues
    setUrlFormValues({ FILTER })
    console.log('function*createProjectSaga -> error', error)
    toast({
      title: 'Ошибка операции!',
      description: 'Не удалось создать проект.\nПовторите попытку позже.',
      type: 'error',
    })
  }
}

export default function* root() {
  yield takeLatest(CREATE_PROJECT.REQUEST, createProjectSaga)
}
